__webpack_require__.p = "/wp-content/plugins/thxuk-bridge/react/build/";